export const translations = {
	'Multi grid': {
		no: 'Multigrid',
	},
};
